import React, { memo } from 'react';
import styled from 'styled-components';
import { mediumMediaQuery } from '../../../common/utilities/sizeHelpers';
import { withScreenSize } from '../../common/utilities/withScreenSize.jsx';
import { ForecastsCardTrayNav } from './scroll/forecastsCardTrayNav';

interface LeftControllButtonsWrapperProps {
    isMobile: boolean;
    isDailyView: boolean;
}

export const LeftControllButtonsWrapper = withScreenSize(memo(({ isMobile, isDailyView }: LeftControllButtonsWrapperProps) => {
    if (isMobile) {
        return null;
    }
    return (
        <Container isDailyView={isDailyView}>
            <ForecastsCardTrayNav />
        </Container>
    );
}));

interface ContainerProps {
    isDailyView: boolean;
}

const Container = styled.div<ContainerProps>`
    display: flex;
    flex-direction: row;
    position: absolute;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
    width: 150px;
    padding-left: 3.7%;

    @media ${mediumMediaQuery} {
        height: 33px;
        width: 100%;
        padding-left: 0;
        left: 0;
        top: ${({ isDailyView }) => isDailyView ? '293px' : '310px'};
        align-items: center;
    }
`;